import { useMemo } from 'react'

import 'reactflow/dist/style.css'

import { Node } from 'dagre'
import { Edge } from 'reactflow'

import { ItemType } from '../../../sdk/common/item-type.enum'
import { IItemTraceability } from '../../../sdk/traceability/traceability.types'
import { ItemNode } from '../components/ItemNode/item-node.comp'
import { VirtualItemNode } from '../components/VirtualItemNode/virtual-item-node.comp'

const getInitialData = (traceability: IItemTraceability[]) => {
  const initialNodes: Node<any>[] = []
  traceability.forEach((item) => {
    if (item.type === ItemType.VIRTUAL) {
      initialNodes.push({
        id: item.id,
        position: { x: 0, y: 0 },
        data: item,
        type: 'virtual',
      })
    } else {
      initialNodes.push({
        id: item.id,
        position: { x: 0, y: 0 },
        data: item,
        type: 'default',
      })
    }
  })

  const initialEdges: Edge<any>[] = []
  traceability.forEach((item) => {
    item.nextItems.forEach((nextItem) => {
      const nextItemData = traceability.find((item) => item.id === nextItem)

      if (nextItemData?.type === ItemType.VIRTUAL) {
        initialEdges.push({
          id: `edge-$${item.id}-${nextItem}}`,
          source: item.id,
          target: nextItem,
          animated: true,
          style: {
            stroke: '#7F56D966',
            strokeWidth: 2,
          },
        })
      } else {
        initialEdges.push({
          id: `edge-$${item.id}-${nextItem}}`,
          source: item.id,
          target: nextItem,
          animated: true,
          style: {
            stroke: '#2a2a2a66',
            strokeWidth: 2,
          },
        })
      }
    })
  })

  return {
    nodes: initialNodes,
    edges: initialEdges,
  }
}

interface IUseItemTree {
  traceability?: IItemTraceability[]
}

export const useItemTree = ({ traceability }: IUseItemTree) => {
  const initialData = useMemo(() => {
    if (traceability) {
      return getInitialData(traceability)
    }
    return {
      nodes: [],
      edges: [],
    }
  }, [traceability])

  const { nodes: initialNodes, edges: initialEdges } = initialData

  // According to the documentation this optimizes the rendering of nodes
  const nodeTypes = useMemo(
    () => ({ default: ItemNode, virtual: VirtualItemNode }),
    [],
  )

  return {
    initialNodes,
    initialEdges,
    nodeTypes,
  }
}
